// Frases motivacionales para inspirar a los usuarios
export const motivationalQuotes = [
  {
    text: "El éxito es la suma de pequeños esfuerzos repetidos día tras día.",
    author: "Robert Collier",
    category: "productividad"
  },
  {
    text: "No esperes el momento perfecto, toma el momento y hazlo perfecto.",
    author: "Anónimo",
    category: "acción"
  },
  {
    text: "La disciplina es el puente entre las metas y los logros.",
    author: "Jim Rohn",
    category: "disciplina"
  },
  {
    text: "Cada día es una nueva oportunidad para ser mejor que ayer.",
    author: "Anónimo",
    category: "crecimiento"
  },
  {
    text: "La única forma de hacer un gran trabajo es amar lo que haces.",
    author: "Steve Jobs",
    category: "pasión"
  },
  {
    text: "El futuro pertenece a quienes creen en la belleza de sus sueños.",
    author: "Eleanor Roosevelt",
    category: "sueños"
  },
  {
    text: "La persistencia es el camino del éxito.",
    author: "Calvin Coolidge",
    category: "persistencia"
  },
  {
    text: "Cada tarea completada es un paso más cerca de tus metas.",
    author: "JAKY Team",
    category: "progreso"
  },
  {
    text: "La organización es la clave de la libertad.",
    author: "Anónimo",
    category: "organización"
  },
  {
    text: "Hoy es el mejor día para empezar algo nuevo.",
    author: "Anónimo",
    category: "inicio"
  }
];

// Frases cortas para mostrar en tiempo real
export const shortMotivationalMessages = [
  "¡Sigue así! 💪",
  "Cada paso cuenta 🚀",
  "¡Excelente progreso! ⭐",
  "¡No te rindas! 🔥",
  "¡Vas por buen camino! 🎯",
  "¡Sigue adelante! 💫",
  "¡Eres increíble! 🌟",
  "¡Casi lo logras! 🏆",
  "¡Muy bien! 👏",
  "¡Continúa! 🚀"
];

// Consejos de productividad
export const productivityTips = [
  "Divide las tareas grandes en pasos pequeños",
  "Prioriza las tareas más importantes primero",
  "Toma descansos regulares para mantener la energía",
  "Celebra cada logro, por pequeño que sea",
  "Mantén tu espacio de trabajo organizado",
  "Establece horarios específicos para cada tarea",
  "Usa la técnica Pomodoro para mantener el enfoque",
  "Revisa tus objetivos diariamente",
  "Aprende a decir 'no' a las distracciones",
  "Visualiza el resultado final de tus esfuerzos"
];
